// src/utils/timezones.ts

// Common timezones for dropdown menus
export const COMMON_TIMEZONES = [
  // UTC
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)' },
  
  // North America
  { value: 'America/New_York', label: 'Eastern Time (ET) - New York, Toronto' },
  { value: 'America/Chicago', label: 'Central Time (CT) - Chicago, Mexico City' },
  { value: 'America/Denver', label: 'Mountain Time (MT) - Denver, Calgary' },
  { value: 'America/Phoenix', label: 'Mountain Time (MT, no DST) - Phoenix, Arizona' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT) - Los Angeles, Vancouver' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT) - Anchorage' },
  { value: 'America/Adak', label: 'Hawaii-Aleutian Time (HST/HDT) - Adak' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Standard Time (HST, no DST) - Honolulu' },
  
  // Central & South America
  { value: 'America/Puerto_Rico', label: 'Atlantic Standard Time (AST) - San Juan' },
  { value: 'America/Halifax', label: 'Atlantic Time (AT) - Halifax' },
  { value: 'America/St_Johns', label: 'Newfoundland Time (NT) - St. John\'s' },
  { value: 'America/Sao_Paulo', label: 'Brasília Time (BRT) - São Paulo, Rio de Janeiro' },
  { value: 'America/Argentina/Buenos_Aires', label: 'Argentina Time (ART) - Buenos Aires' },
  { value: 'America/Santiago', label: 'Chile Time (CLT) - Santiago' },
  
  // Europe & Africa
  { value: 'Europe/London', label: 'Greenwich Mean Time/British Summer Time (GMT/BST) - London' },
  { value: 'Europe/Dublin', label: 'Irish Standard Time (IST) - Dublin' },
  { value: 'Europe/Lisbon', label: 'Western European Time (WET) - Lisbon' },
  { value: 'Europe/Paris', label: 'Central European Time (CET) - Paris, Berlin, Rome, Madrid' },
  { value: 'Europe/Athens', label: 'Eastern European Time (EET) - Athens, Helsinki, Bucharest' },
  { value: 'Europe/Moscow', label: 'Moscow Standard Time (MSK) - Moscow' },
  { value: 'Africa/Cairo', label: 'Eastern European Time (EET) - Cairo' },
  { value: 'Africa/Johannesburg', label: 'South Africa Standard Time (SAST) - Johannesburg' },
  { value: 'Africa/Nairobi', label: 'East Africa Time (EAT) - Nairobi' },
  
  // Middle East
  { value: 'Asia/Dubai', label: 'Gulf Standard Time (GST) - Dubai, Abu Dhabi' },
  { value: 'Asia/Tehran', label: 'Iran Standard Time (IRST) - Tehran' },
  { value: 'Asia/Jerusalem', label: 'Israel Standard Time (IST) - Jerusalem' },
  { value: 'Asia/Riyadh', label: 'Arabia Standard Time (AST) - Riyadh' },
  
  // Asia
  { value: 'Asia/Kolkata', label: 'India Standard Time (IST) - Mumbai, Delhi' },
  { value: 'Asia/Kathmandu', label: 'Nepal Time (NPT) - Kathmandu' },
  { value: 'Asia/Dhaka', label: 'Bangladesh Standard Time (BST) - Dhaka' },
  { value: 'Asia/Bangkok', label: 'Indochina Time (ICT) - Bangkok, Hanoi' },
  { value: 'Asia/Singapore', label: 'Singapore Time (SGT) - Singapore, Kuala Lumpur' },
  { value: 'Asia/Shanghai', label: 'China Standard Time (CST) - Beijing, Shanghai' },
  { value: 'Asia/Seoul', label: 'Korea Standard Time (KST) - Seoul' },
  { value: 'Asia/Tokyo', label: 'Japan Standard Time (JST) - Tokyo, Osaka' },
  
  // Oceania
  { value: 'Australia/Perth', label: 'Australian Western Standard Time (AWST) - Perth' },
  { value: 'Australia/Adelaide', label: 'Australian Central Standard Time (ACST) - Adelaide' },
  { value: 'Australia/Darwin', label: 'Australian Central Standard Time (ACST, no DST) - Darwin' },
  { value: 'Australia/Brisbane', label: 'Australian Eastern Standard Time (AEST, no DST) - Brisbane' },
  { value: 'Australia/Sydney', label: 'Australian Eastern Standard Time (AEST) - Sydney, Melbourne' },
  { value: 'Pacific/Auckland', label: 'New Zealand Standard Time (NZST) - Auckland, Wellington' },
  { value: 'Pacific/Fiji', label: 'Fiji Time (FJT) - Suva' },
  { value: 'Pacific/Tongatapu', label: 'Tonga Time (TOT) - Nuku\'alofa' },
  
  // Additional Special Cases
  { value: 'America/Juneau', label: 'Alaska Time (AKT) - Juneau' },
  { value: 'America/Indiana/Indianapolis', label: 'Eastern Time (ET, varies by county) - Indianapolis' },
  { value: 'America/Boise', label: 'Mountain Time (MT) - Boise, Idaho' },
];

// Helper function to get the user's local timezone
export const getUserLocalTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    console.error('Error getting local timezone:', error);
    return 'UTC';
  }
}; 